import React from "react";
import { cmsColSpanClass } from "@/components/organisms/CmsForm/cmsColSpan";
import type { CmsColSpan } from "@/components/organisms/CmsForm/cmsColSpan";

interface CmsFieldsetProps {
  /** Group title when there is no group-level error. */
  legend: string;
  /** When set, shown as the legend text and applies fieldset error styling. */
  groupError?: string | null;
  /** Span in `.cms-form-page__fields` (1–6; default 6). */
  colSpan?: CmsColSpan;
  className?: string;
  children: React.ReactNode;
}

/**
 * CMS form field group with the same 6-column grid as `.cms-form-page__fields`.
 * Child fields should use `CmsField` (or siblings) with optional `colSpan`.
 */
export function CmsFieldset({
  legend,
  groupError,
  colSpan = 6,
  className,
  children,
}: CmsFieldsetProps) {
  const hasGroupError = Boolean(groupError);

  return (
    <fieldset
      className={[
        "cms-field",
        "cms-field--fieldset",
        cmsColSpanClass(colSpan),
        hasGroupError && "cms-field--fieldset-error",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <legend className="cms-field__label">
        {groupError ?? legend}
      </legend>
      {children}
    </fieldset>
  );
}
